import { createAction } from '@reduxjs/toolkit';

import { SET_BANNER_MESSAGE } from '@/types/store/actions';
import { type BannerMessage } from '@/types/store/reducers';

export const setBannerMessage = createAction<BannerMessage, typeof SET_BANNER_MESSAGE>(SET_BANNER_MESSAGE);
